import { Toaster as Sonner } from 'sonner';
import { useThemeMode } from '../../shared/contexts/ThemeContext';
import { DURATION } from '../../shared/styles/animations';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useThemeMode();

  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      duration={4000}
      toastOptions={{
        classNames: {
          toast:
            // eslint-disable-next-line i18next/no-literal-string -- CSS class names, not user copy
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          // eslint-disable-next-line i18next/no-literal-string -- CSS class names, not user copy
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            // eslint-disable-next-line i18next/no-literal-string -- CSS class names, not user copy
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            // eslint-disable-next-line i18next/no-literal-string -- CSS class names, not user copy
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
        // Use centralized animation duration for consistency
        style: {
          '--toast-animation-duration': `${DURATION.slow}ms`,
        } as React.CSSProperties,
      }}
      {...props}
    />
  );
};

export { Toaster };
